import { useApiEffect } from 'framework/hooks/useApiEffect';
import { useLazyEffect } from 'framework/hooks/useLazyEffect';
import { useTrigger } from 'framework/hooks/useTrigger';
import { getEazyworksPatientDataById_handle } from 'gen/ApiClient';
import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { RestrictedPageX } from 'shared/layout/RestrictedPageX';
import { EazyworksPatientDataStack } from '../detailX/migrations/eazyworks-tab';
import { CardX } from 'framework/components/cards/CardX';
import { useLocalization } from 'localization/useLocalization';
import { Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import { EazyworkPatientImportRoute } from './eazyworks-klanten-list.page';

export const EazyworkKlantDetailPage = () => {
	const { id } = useParams<{ id: string }>();
	const [trigger] = useTrigger();
	const [data, reloadDetail] = useApiEffect(getEazyworksPatientDataById_handle, Number(id));
	const strings = useLocalization();
	const { push } = useHistory();

	useLazyEffect(() => {
		reloadDetail();
	}, [trigger]);

	if (!data) {
		return <div></div>;
	}

	return (
		<RestrictedPageX pageClaim='Patients'>
			<div
				className='df-col gap-16'
				style={{
					padding: 16,
					// paddingLeft: 8,
					maxWidth: 1280,
				}}>
				<EazyworksPatientDataStack item={data} />
				<CardX>
					<Button
						startIcon={<GetAppIcon />}
						onClick={() => push(EazyworkPatientImportRoute.replace(':id', data.id.toString()))}
						variant='outlined'
						color='primary'
						size='small'>
						{strings.import}
					</Button>
				</CardX>
			</div>
		</RestrictedPageX>
	);
};
